import { memo } from 'react';
import { getContext } from '@picsart/miniapps-sdk';
import IconCrossLarge from '@picsart/icons/IconCrossLarge';
import IconTickLarge from '@picsart/icons/IconTickLarge';
import View from '@picsart/view/View';
import Text from '@picsart/text/Text';
import { InlineButton, ControlSizesLG } from '@picsart/inlineButton';
import { useTranslator } from '@picsart/rc/services/localization';

import { BATCH_TOOLS } from 'pages/Batch/configs';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import useToolCancelApply from 'hooks/useToolCancelApply';
import { MobileExport } from 'pages/Batch/components/Export';
import { IS_ONE_TOOL } from 'configs/constants';

import testIds from './testIds';

const MobileHeader = () => {
  const translate = useTranslator();
  const { data, activeTool, selectedData } = useBatchData();
  const { handleCancel, handleDone, isDone, isToolApplying, isApplyTriggered } = useToolCancelApply();
  const isApplyBtnDisabled = !isDone || isToolApplying || isApplyTriggered;

  const isDisabledMobileExport = (IS_ONE_TOOL && (!data.length || !selectedData.find(el => el.pendingResult)))
    || ((!data.length || !selectedData.find(el => el.isProcessed)) && !IS_ONE_TOOL);

  return (
    <View flexDirection="row" height="100%" alignItems="end">
      {!activeTool || activeTool === BATCH_TOOLS.upload || IS_ONE_TOOL ? (
        <View flexDirection="row" justifyContent="space-between" width="100%">
          <InlineButton
            data-testid={testIds.closeMiniappBtn}
            onClick={() => getContext().handlers.close()}
            size={ControlSizesLG}
            startIcon={IconCrossLarge}
            isWithoutBorder
            isWithoutBackground
          />

          <View flexDirection="row">
            <MobileExport isDisabled={isDisabledMobileExport} />
          </View>
        </View>
      ) : (
        <View flexDirection="row">
          <InlineButton
            data-testid={testIds.cancelBtn}
            onClick={handleCancel}
            isWithoutBorder
            isWithoutBackground
          >
            <Text>{translate('Cancel')}</Text>
          </InlineButton>

          <InlineButton
            data-testid={testIds.applyBtn}
            onClick={handleDone}
            endIcon={IconTickLarge}
            isWithoutBorder
            isWithoutBackground
            isDisabled={isApplyBtnDisabled}
          >
            <Text>{translate('Apply')}</Text>
          </InlineButton>
        </View>
      )}
    </View>
  );
};

export default memo(MobileHeader);
